export function formatMoney(value) {
  const number = Number(value);
  const amount = Number.isFinite(number) ? number : 0;
  return `₹${amount.toLocaleString("en-IN")}`;
}

export function formatDate(value) {
  if (!value) return "—";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatLabel(value) {
  if (value === null || value === undefined || value === "") return "—";
  return String(value)
    .replace(/[_-]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function previewList(items, max = 2) {
  if (!Array.isArray(items) || items.length === 0) return "—";
  const shown = items.slice(0, max).join(", ");
  const extra = items.length - max;
  return extra > 0 ? `${shown} +${extra}` : shown;
}

export function locationText(user) {
  if (!user) return "—";
  const parts = [user.village, user.subDistrict, user.district, user.state, user.pincode]
    .map((part) => String(part || "").trim())
    .filter(Boolean);
  return parts.length ? parts.join(", ") : "—";
}

export function apiErrorMessage(error, fallback) {
  return error?.response?.data?.message || fallback;
}

export function detailEntries(details) {
  if (!details || typeof details !== "object" || Array.isArray(details)) return [];
  return Object.entries(details).filter(([, value]) => value !== null && value !== undefined && value !== "");
}

export function displayValue(value) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
